import React, { useState, useEffect, useContext } from "react";
import logo from "../images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../utils/AuthContext";
import { auth } from "../firebase";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { PopupMenu } from "react-simple-widgets";
import { FaUser } from "react-icons/fa";

const Navbar = () => {
  const navigate = useNavigate();
  const [isAuth, setIsAuth] = useState(useContext(AuthContext));
  // console.log(isAuth['providerData'][0].uid);

  const [userData, setuserData] = useState(null);

  const fetchDocument = async () => {
    // console.log(userData);
    if (isAuth && !userData) {
      try {
        // console.log("navbar");
        const docRef = doc(db, "users", isAuth["providerData"][0].uid);
        const docSnapshot = await getDoc(docRef);

        if (docSnapshot.exists()) {
          setuserData(docSnapshot.data());
          // console.log(docSnapshot.data());
        } else {
          // console.log("Document not found");
          // console.log(isAuth["providerData"][0].uid);
          navigate("/login");
          // setIsAuth(null);
          // alert("Error logging in. Please try again.")
        }
      } catch (error) {
        // console.log("Error fetching document from Firebase:", error);
        navigate("/");
        // setIsAuth(null);
        // alert("Error logging in. Please try again.")
      }
    }
  };

  useEffect(() => {
    fetchDocument();
    // console.log(userData);
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsAuth(null);
      navigate("/login");
    } catch (error) {
      console.log("Error logging out:", error);
    }
  };

  return (
    <nav className="flex items-center justify-between shadow-sm fixed top-0 left-0 z-50 w-full bg-white">
      <div className="flex justify-between max-w-7xl mx-auto w-full items-center">
        
        <div className="flex items-center bg-white bg-opacity-30 p-5 rounded-sm hover:bg-opacity-70 cursor-pointer transform transition-all ease-out">
          <a href="/">
            <img src={logo} alt="Logo" className=" h-10 w-10" />
          </a>
        </div>

      <ul className="flex gap-4 z-50">
            <li className="">
              <a href="#about" className="text-gray-400 hover:text-orange-500 cursor-pointer hover:border-b-2 border-orange-500 py-2 transform transition ease-in-out duration-300">About</a>
            </li>
            <li className="">
              <a href="#services" className="text-gray-400 hover:text-orange-500 cursor-pointer hover:border-b-2 border-orange-500 py-2 transform transition ease-in-out duration-300">Services</a>
            </li>
            <li className="">
              <a href="#testi" className="text-gray-400 hover:text-orange-500 cursor-pointer hover:border-b-2 border-orange-500 py-2 transform transition ease-in-out duration-300">Testimonials</a>
            </li>
          </ul>

      {!isAuth && (
        <div className="flex gap-2">
          <Link
            to="/login"
            className="  px-4 py-2 border border-orange-500 text-gray-400 hover:text-black hover:bg-orange-500 transform transition ease-in-out rounde"
          >
            Log In
          </Link>
          <Link
            to="/signup"
            className=" px-4 py-2 border border-orange-500 text-gray-400 hover:text-black hover:bg-orange-500 transform transition ease-in-out rounde"
          >
            Sign Up
          </Link>
        </div>
      )}

      {isAuth && userData && (
        <div className="flex items-center gap-2">
          <Link
            to="/"
            className="px-4 py-2 border border-orange-500 text-gray-400 hover:text-black hover:bg-orange-500 transform transition ease-in-out rounde"
          >
            Home
          </Link>

          <Link
            to="/portal"
            className="px-4 py-2 border border-orange-500 text-gray-400 hover:text-black hover:bg-orange-500 transform transition ease-in-out rounde"
          >
            Portal
          </Link>

          {userData.userType == "Customers" && (
            <Link
              to="/dashboard"
              className="px-4 py-2 border border-orange-500 text-gray-400 hover:text-black hover:bg-orange-500 transform transition ease-in-out rounde"
            >
              Request
            </Link>
          )}

          {userData.userType == "Providers" && (
            <Link
              to="/dashboard"
              className="px-4 py-2 border border-orange-500 text-gray-400 hover:text-black hover:bg-orange-500 transform transition ease-in-out rounde "
            >
              Provide
            </Link>
          )}

          <PopupMenu className="">
            <button className="px-4 py-2 border border-orange-500 text-gray-400 hover:text-black hover:bg-orange-500 transform transition ease-in-out rounde ">
              <div className="flex ">
                <FaUser className="mr-2" />
                Profile
              </div>
            </button>

            <div className="bg-white rounded-sm ">
              <div className="card-body px-4 py-4 text-center">
                <div className="flex justify-center mb-4">
                  <FaUser className="text-xl text-orange-500" />
                </div>

                <h5 className="mb-4 mt-2 text-black">{userData["name"]}</h5>
                <hr />

                <p className="mb-4 mt-2">{userData["email"]}</p>
                <hr />

                <p className="mb-4 mt-2">{userData["userType"]}</p>
                <hr />

                <hr />
                <div className="d-grid mt-4">
                  <button
                    className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-5 rounded mr-2"
                    onClick={handleLogout}
                  >
                    <small>Logout</small>
                  </button>
                </div>
              </div>
            </div>
          </PopupMenu>
        </div>
      )}
      
      </div>
    </nav>
  );
};

export default Navbar;
